import type { MaterialItemFragment } from "~/gql/queries/material.generated";

import hardgoodContinuation from "~fulfill/product/hardgoods/helpers/hardgoodContinuation";

export const HARDGOOD_QUERY_PARAM = "hardGood";

export const buildHardgoodDeepLinkRoute = (hardgoodId: string): string =>
	`${hardgoodContinuation.HARDGOODS_PATH}?${new URLSearchParams({ [HARDGOOD_QUERY_PARAM]: hardgoodId })}`;

export type HardgoodDeepLink =
	| { kind: "missing" }
	| { kind: "none" }
	| { kind: "open"; materialItem: MaterialItemFragment }
	| { kind: "pending" };

export interface HardgoodDeepLinkInput {
	hardgoodId: null | string;
	hasMorePages: boolean;
	isError: boolean;
	isLoading: boolean;
	materialItems: readonly MaterialItemFragment[];
}

const resolveHardgoodDeepLink = ({
	hardgoodId,
	hasMorePages,
	isError,
	isLoading,
	materialItems
}: HardgoodDeepLinkInput): HardgoodDeepLink => {
	if (!hardgoodId) return { kind: "none" };
	const materialItem = materialItems.find((item) => item.id === hardgoodId);
	if (materialItem) return { kind: "open", materialItem };
	if (isError) return { kind: "missing" };
	if (isLoading || hasMorePages) return { kind: "pending" };
	return { kind: "missing" };
};

export default resolveHardgoodDeepLink;
